import React from 'react';
import { useDemoContext } from '../contexts/DemoContext';
import OriginalHeader from '../shared/Header';
import PropTypes from 'prop-types';
import '../stylesheets/components/DemoHeader.css';

/**
 * Demo-aware Header wrapper that restricts navigation when in demo mode
 */
const DemoHeader = ({ onCurrentUserChange }) => {
  const { isDemoMode } = useDemoContext();

  if (!isDemoMode) {
    // If not in demo mode, render the original header
    return <OriginalHeader onCurrentUserChange={onCurrentUserChange} />;
  }

  // In demo mode, render a restricted header
  return (
    <div className="demo-header-overlay">
      <div className="demo-header-disabled">
        <OriginalHeader onCurrentUserChange={onCurrentUserChange} />
      </div>
    </div>
  );
};

DemoHeader.propTypes = {
  onCurrentUserChange: PropTypes.any
};

export default DemoHeader;
